
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowDown = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M23.292 10.24a1.413 1.413 0 00-1.994.127l-7.448 8.464a.251.251 0 01-.438-.166V1.413a1.412 1.412 0 10-2.824 0v17.252a.251.251 0 01-.438.166L2.7 10.367a1.413 1.413 0 10-2.119 1.867L10.233 23.2a2.352 2.352 0 003.534 0l9.652-10.967a1.412 1.412 0 00-.127-1.993z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 23.739l-.096-.003a1.492 1.492 0 01-1.031-.505L.624 11.587a.5.5 0 11.75-.661l10.125 11.502V.757a.5.5 0 011 0v21.669l10.125-11.499a.502.502 0 01.705-.045.501.501 0 01.045.706l-10.25 11.643a1.497 1.497 0 01-1.124.508z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24a.755.755 0 01-.26-.047l-.022-.008a.732.732 0 01-.249-.165L.97 13.28a.744.744 0 010-1.06c.141-.142.33-.22.53-.22s.389.078.53.22l9.22 9.22V.75a.75.75 0 011.5 0v20.689l9.22-9.22a.746.746 0 011.06.001.744.744 0 010 1.06l-10.5 10.5a.763.763 0 01-.246.164l-.027.01A.746.746 0 0112 24z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowDown.displayName = 'IconArrowDown';
export default IconArrowDown;